module.exports = __webpack_public_path__ + "static/media/thumb.8545136b.jpg";